// extracted by mini-css-extract-plugin
module.exports = {"root":"PubDate__root--Zeoon","bounce":"PubDate__bounce--2cHnW"};